<div class="suggestion teacher-suggestion">
	{{#if moreResults}}
		<div class="suggesiton-primary more-suggestions">View all matching teachers</div>
	{{else}}
		<div class="suggestion-photo" style="background-image:url({{teacherImage}});"></div>
		<div class="suggestion-info">
			<div class="suggestion-primary teacher-name">{{teacherName}}</div>
			<div class="suggestion-secondary teacher-location">{{schoolName}}, {{cityName}}, {{stateCode}}</div>
		</div>
	{{/if}}
</div>
